// extracted by mini-css-extract-plugin
export default {"station-details":"styles_station-details__De-vv","delete-button":"styles_delete-button__ZjwIL"};